"use client"

import {Popover as PopoverPrimitive} from "radix-ui"
import type React from "react"

import {cn} from "@/lib/cn"

/**
 * DIZED popover on Radix Popover: same card material as `Card` (gradient
 * surface, lit edge) so a floating panel reads as the same product as the
 * surface it sits over.
 *
 * Radix, not a native element, because the only current consumer is
 * `DateRangeFields`'s Calendar trigger — the OS date popup is unstyleable
 * chrome, unlike the form controls that stay native (see `Checkbox` in
 * `input.tsx`).
 */
export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger

export const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 8,
  ...props
}: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-auto origin-(--radix-popover-content-transform-origin) rounded-card card-elev p-3",
        "text-foreground shadow-card-lit outline-none",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2",
        "data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
)
